import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import {
  isInteger,
  isValidNameWithSpace,
  normalizeDecimal,
  normalizeRate,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextArea,
  renderTextField,
} from '../../../../../components/reduxFields';
import { getMasterData, getServiceCodeDetails, saveServiceCodes } from '../actions/ServiceCodeActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../components/buttons';
import validate from './validate';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../modules/AppConfig/actions';
import { MODULE } from '../constants/ApiConstants';
import { displayCustomError, showNormalizedRate } from '../../../../../actions/utilAction';
class ServiceCodeModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterUnitType: props.master_data ? props.master_data.masterUnitType : [],
      masterRoundingRules: props.master_data ? props.master_data.masterRoundingRules : [],
      serviceCodeData: props.serviceCodeData,
      serviceCodeId: props.serviceCodeId ? props.serviceCodeId : null,
      // serviceCodeExistsErrorMessage: null,
    };
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.clearFieldErrorArray();
      this.props.closeDialog();
    }
  };

  componentWillMount() {
    // this.props.getMasterData();
    if (this.props.serviceCodeId) {
      this.props.getServiceCodeDetails(this.props.serviceCodeId);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterUnitType: masterData.masterUnitType,
        masterRoundingRules: masterData.masterRoundingRules,
      });
    }

    if (nextProps.serviceCode_created && this.props.serviceCode_created !== nextProps.serviceCode_created) {
      this.setState({ open: false });
      this.props.closeDialog();
    }

    // if (nextProps.fieldError && this.props.fieldError !== nextProps.fieldError) {

    //   if (nextProps.fieldError.length > 0) {
    //     let message = nextProps.fieldError[0].message;
    //     let data = nextProps.fieldError[0].data;
    //     let statusCode = nextProps.fieldError[0].statusCode;
    //     this.setState({ serviceCodeExistsErrorMessage: message });
    //   }
    // }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  /** *******************     Input field exist check        ***********************/
  checkFieldDataExistence = (input, value, labelName) => {
    // this.setState({ serviceCodeExistsErrorMessage: null });
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': (this.props.initialValues && this.props.initialValues.serviceCodeId) ? this.props.initialValues.serviceCodeId : 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };
  /** *****   End Input field exist check    **********/

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  onSubmitHandler(formData) {
    // console.log(formData);
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    if (!formData.isBillable) {
      formData.isBillable = false;
    }
    // console.log('Form data this.state.serviceCodeId : ',this.state.serviceCodeId);
    formData.id = this.state.serviceCodeId ? this.state.serviceCodeId : 0;
    formData.serviceCode = formData.serviceCode.trim();
    formData.description = formData.description ? formData.description.trim() : '';
    formData.unitTypeName = undefined;
    formData.ruleName = undefined;
    formData.type = 'CPTCodes';
    this.props.clearFieldErrorArray();

    // ---------------Start Save to modifierModel in service code------------
    // console.log(formData.modifierModel);
    let listModifiers = [];
    if (formData.modifierModel && formData.modifierModel.length) { //  Save Tags
      formData.modifierModel.filter((data, i) => {
        if (data.modifier && data.modifier.trim() != '' && data.rate) {
          let currentModifier = {
            'modifierID': data.modifierID ? data.modifierID : 0,
            'serviceCodeId': data.serviceCodeId ? data.serviceCodeId : this.state.serviceCodeId ? this.state.serviceCodeId : 0,
            'modifier': data.modifier.trim(),
            'rate': data.rate,
          };
          listModifiers.push(currentModifier);
        }
        return listModifiers;
      });
    }
    formData.modifierModel = listModifiers;
    // ---------------End Save to modifierModel in service code------------

    this.props.saveServiceCodes(formData, formData.serviceCodeId);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  addModifierRow = () => { };
  removeModifierRow = (i) => { };

  renderModifiersTemplate = ({ fields }) => {
    this.addModifierRow = (e) => {
      fields.push({});
    };

    this.removeModifierRow = (i, e) => {
      fields.remove(i);
    };

    return (
      <div>
        {fields.map((modifierModel, i) =>
          <div id="currentDiv" className="row" key={i}>
            <div className="col-sm-4">
              <Field
                name={`modifierModel[${i}].modifier`}
                type="text"
                maxLength="20"
                label="Modifier"
                component={renderTextField}
              />
            </div>
            <div className="col-sm-4 pdl-40">
              <Field
                name={`modifierModel[${i}].rate`}
                type="text"
                maxLength="8"
                label="Rate Per Unit ($)"
                component={renderTextField}
                normalize={normalizeDecimal}
              />
              {fields.length === i + 1 ?
                <div>
                  {fields.length > 1 ?
                    <button className=" additem removeitem"
                      onClick={this.removeModifierRow.bind(this, i)}
                      title="Remove Service Codes"
                      type="button">
                      <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                    </button>
                    : ''}
                  <button className="additem" title="Add Service Codes" onClick={(e) => this.addModifierRow()} type="button">
                    <b className="fa fa-plus-square greenfont" aria-hidden="true"></b>
                  </button>
                </div>
                :
                <div>
                  <button className="additem"
                    onClick={this.removeModifierRow.bind(this, i)}
                    title="Remove Service Codes"
                    type="button">
                    <b className="fa fa-minus-square redfont" aria-hidden="true"></b>
                  </button>
                </div>
              }

            </div>
          </div>
        )
        }
      </div>
    );
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title={this.props.serviceCodeData ? 'Edit Service Code' : 'Add Service Code'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    autoFocus={true}
                    name="serviceCode"
                    type="text"
                    maxLength='10'
                    onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Code')}
                    customError={displayCustomError('SERVICECODE', this.props.fieldError)}
                    label="Service Code"
                    normalize={isValidNameWithSpace}
                    disabled={this.props.serviceCodeData ? true : false}
                    component={renderTextField} />

                </div>
                <div className="col-sm-12 col-md-6 require mt-35">
                  <Field
                    name="ruleID"
                    label="Rounding Rule"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterRoundingRules}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="unitDuration"
                    type="text"
                    maxLength="3"
                    label="Unit Duration"
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
                <div className="col-sm-12 col-md-6 require mt-35">
                  <Field
                    name="unitTypeID"
                    label="Unit Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterUnitType}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="ratePerUnit"
                    type="text"
                    maxLength="8"
                    label="Rate Per Unit ($)"
                    component={renderTextField}
                    normalize={normalizeDecimal}
                  />
                </div>
              </div>
              <FieldArray name="modifierModel" component={this.renderModifiersTemplate} />
              <div className="row">
                <div className="col-sm-12 col-md-12 require">
                  <Field
                    name="description"
                    type="text"
                    maxLength="1000"
                    label="Description"
                    // normalize ={isValidNameWithSpace}
                    component={renderTextArea} />
                  <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="isBillable"
                    label="Billable"
                    component={renderCheckBox}
                  />
                </div>
                <div className="col-sm-6">
                  <Field className="mt20 mb0"
                    name="isRequiredAuthorization"
                    label="Required Authorization"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

const selector = formValueSelector('ServiceCodeModalForm');
function mapStateToProps(state, ownProps) {
  // console.log('state.service_code.master_data.....',state.service_code.master_data);showNormalizedRate
  // console.log(ownProps.serviceCodeData);
  // let initialData = {
  //   Procedure: [{}],
  // };
  // if (ownProps.serviceCodeData) {
  //   initialData = ownProps.serviceCodeData;
  // }
  let initialValueData = {
    modifierModel: [{}],
  };
  if (ownProps.serviceCodeId && state.service_code.serviceCodeDetails) {
    let serviceCodeData = state.service_code.serviceCodeDetails.data;
    let modifierModel = [];
    if (serviceCodeData.modifierModel && serviceCodeData.modifierModel.length) {
      serviceCodeData.modifierModel.filter((data, i) => {
        modifierModel.push({
          'serviceCodeId': data.serviceCodeId,
          'modifierID': data.modifierID,
          'modifier': data.modifier,
          'rate': showNormalizedRate(data.rate),
          'key': data.key,
        });
        return modifierModel;
      });
    } else {
      modifierModel = [{}];
    }

    initialValueData = {
      ...serviceCodeData,
      ratePerUnit: showNormalizedRate(serviceCodeData.ratePerUnit),
      modifierModel: modifierModel,
      serviceCodeId: serviceCodeData.id,
    };

    // initialValueData = {
    //   'serviceCodeId': ownProps.serviceCodeData.serviceCodeId,
    //   'serviceCode': ownProps.serviceCodeData.serviceCode,
    //   'ruleID': ownProps.serviceCodeData.ruleID,
    //   'unitDuration': ownProps.serviceCodeData.unitDuration,
    //   'unitTypeID': ownProps.serviceCodeData.unitTypeID,
    //   'ratePerUnit': showNormalizedRate(ownProps.serviceCodeData.ratePerUnit),
    //   'isBillable': ownProps.serviceCodeData.isBillable,
    //   'description': ownProps.serviceCodeData.description,
    //   'isRequiredAuthorization': ownProps.serviceCodeData.isRequiredAuthorization,
    // }
  }

  // initialValueData['modifierModel'] = ownProps.serviceCodeData && ownProps.serviceCodeData.modifierModel.length > 0 ? ownProps.serviceCodeData.modifierModel : [{}];

  return {
    description: selector(state, 'Description'),
    master_data: state.service_code.master_data,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
    serviceCodeId: ownProps.serviceCodeData ? ownProps.serviceCodeId : 0,
    // initialValues: ownProps.serviceCodeData ? {
    //   ServiceCode: ownProps.serviceCodeData.ServiceCode,
    //   RuleID: ownProps.serviceCodeData.RuleID,
    //   UnitDuration: ownProps.serviceCodeData.UnitDuration,
    //   UnitTypeID: ownProps.serviceCodeData.UnitTypeID,
    //   RatePerUnit: showNormalizedRate(ownProps.serviceCodeData.RatePerUnit),
    //   IsBillable: ownProps.serviceCodeData.IsBillable,
    //   Description: ownProps.serviceCodeData.Description,
    //   IsRequiredAuthorization: ownProps.serviceCodeData.IsRequiredAuthorization,

    // } : {},
  };
}

ServiceCodeModal = reduxForm({
  form: 'ServiceCodeModalForm',
  validate,
  enableReinitialize: true,
})(ServiceCodeModal);

export default connect(mapStateToProps, { checkFieldExistence, clearFieldErrorArray, getMasterData, saveServiceCodes, getServiceCodeDetails })(ServiceCodeModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/serviceCode/components/ServiceCodeModal.js